var _rect, _rect2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMbSearch = function SvgMbSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 38,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.813,
    height: 36.813,
    x: 1.344,
    y: 0.594,
    fill: "#F3F3F3",
    rx: 18.406
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36.813,
    height: 36.813,
    x: 1.344,
    y: 0.594,
    stroke: "#E8E9E9",
    strokeWidth: 1.188,
    rx: 18.406
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mbSearch_svg__a",
    width: 29,
    height: 30,
    x: 5,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M5.5 4.75H34v28.5H5.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mbSearch_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#323941",
    d: "M17.512 24.024q-3.042 0-5.152-2.11t-2.11-5.152 2.11-5.152 5.152-2.11 5.152 2.11 2.11 5.152q0 1.272-.427 2.43a6.8 6.8 0 0 1-1.14 2.014l6.833 6.833a.86.86 0 0 1 .252.62.84.84 0 0 1-.252.631.85.85 0 0 1-.626.258.85.85 0 0 1-.625-.258l-6.833-6.833a6.8 6.8 0 0 1-2.049 1.151 7 7 0 0 1-2.395.416m0-1.781q2.295 0 3.888-1.593t1.593-3.888-1.593-3.888-3.888-1.593-3.888 1.593-1.593 3.888 1.593 3.888 3.888 1.593"
  }))));
};
export default SvgMbSearch;